import AnalyticCard from "../../analyticCard/analyticCard";

const CardDashboard = () => {
    const a = <br/>
    return(
        <div className={'grid col-2'}>
            <div className="fleetAnalytics">
                <div className="sf-medium font-18 margin-b-15 highlight-color">Fleet Performance</div>
                <ul className="grid col-2 ">
                    <AnalyticCard color={'#5E98FF'}
                                  backColor={'#EFF7FF'}
                                  data={{number: 106, title: <span>Active<br/> Vehicles</span>}}/>
                    <AnalyticCard color={'#5E98FF'}
                                  backColor={'#F5F5F5'}
                                  data={{number: 19, title: <span>Average<br/>Alerts</span>}}/>
                </ul>
            </div>
            <div className="driverAnalytics">
                <div className="sf-medium font-18 margin-b-15 highlight-color">Driver Performance</div>
                <ul className="grid col-2">
                    <AnalyticCard color={'#36BA6E'}
                                  backColor={'#E3F5EA'}
                                  data={{number: 58, title: <span>Improved<br/> Drivers</span>}}/>
                    <AnalyticCard
                                  data={{number: '23', title: <span>Distracted<br/> Drivers</span>}}/>
                </ul>
            </div>
        </div>
    )
}

export default CardDashboard;
